import { useQuery } from "react-query";
import { client } from "shared/helpers/client";

interface ControlledResponse {
    data: any[];
    totalCount: number;
  }

export const getControlledOffices = () => {
  return client<ControlledResponse>("/OwnerBooking/GetAllControlledOffices");
};


export function useControlledOffices() {
    const result = useQuery(['controlledOffices'], async () => {
        const { response } = await getControlledOffices()
        if (response) return response
    })
    return { ...result, controlledOffices: result.data?.data ?? [],totalCount:result.data?.totalCount ?? 0 }
}